import React, { useEffect, useRef, useState } from 'react';
import i18n from '../locale/i18next';
import uzb from '../Images/world.webp';
import rus from '../Images/russia.webp';
import eng from '../Images/uk.webp';

const LANGS = [
  { id: 'uz', code: 'UZ', name: "O'zbekcha", img: uzb },
  { id: 'ru', code: 'RU', name: 'Русский', img: rus },
  { id: 'en', code: 'EN', name: 'English', img: eng },
];

/** Til tanlash: bayroq + kod; bosilganda uchta tildan biri tanlanadi. */
export default function LangSwitch() {
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState((i18n.language || 'uz').slice(0, 2));
  const box = useRef(null);
  const cur = LANGS.find(l => l.id === lang) || LANGS[0];

  useEffect(() => {
    const onLang = (l) => setLang((l || 'uz').slice(0, 2));
    i18n.on('languageChanged', onLang);
    return () => i18n.off('languageChanged', onLang);
  }, []);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!box.current?.contains(e.target)) setOpen(false); };
    const esc = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', esc); };
  }, [open]);

  const pick = (id) => { setOpen(false); if (id !== lang) i18n.changeLanguage(id); };

  return (
    <div className='lsw' ref={box}>
      <button type='button' className={`lsw-btn${open ? ' on' : ''}`} aria-haspopup='listbox' aria-expanded={open}
        aria-label={cur.name} onClick={() => setOpen(o => !o)}>
        <img src={cur.img} alt='' />
        <span>{cur.code}</span>
        <svg viewBox='0 0 24 24' aria-hidden='true'><path d='m6 9 6 6 6-6' /></svg>
      </button>
      {open && (
        <ul className='lsw-menu' role='listbox' aria-label='Language'>
          {LANGS.map(l => (
            <li key={l.id}>
              <button type='button' role='option' aria-selected={l.id === lang} className={l.id === lang ? 'on' : ''} onClick={() => pick(l.id)}>
                <img src={l.img} alt='' />
                <span>{l.name}</span>
                <small>{l.code}</small>
                {l.id === lang && <svg viewBox='0 0 24 24' aria-hidden='true'><path d='m5 12.5 4.5 4.5L19 7.5' /></svg>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
